// import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
// import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';

export const SidebarData = [
  // {
  //   title: 'Workspace',
  //   path: '/',
  //   icon: <HomeOutlinedIcon />,
  //   type: 'item',
  // },
  {
    title: 'Properties',
    path: '/properties',
    icon: <HomeWorkOutlinedIcon />,
    type: 'item',
  },
  {
    title: 'Files',
    path: '/files',
    icon: <FolderOpenOutlinedIcon />,
    type: 'item',
  },
  {
    title: 'Calendar',
    path: '/calendar',
    icon: <CalendarMonthOutlinedIcon />,
    type: 'item',
  },
  {
    title: 'Contacts',
    path: '/contacts',
    icon: <ContactPhoneOutlinedIcon />,
    type: 'item',
  },
  {
    title: 'Pipeline',
    path: '/pipeline',
    icon: <DashboardCustomizeOutlinedIcon />,
    type: 'item',
  },
  // {
  //   title: 'Marketplace',
  //   path: '/marketplace',
  //   icon: <StorefrontOutlinedIcon />,
  //   type: 'item',
  // },
  {
    title: 'Reconciliation',
    path: '/reconciliation',
    icon: <MonetizationOnOutlinedIcon />,
    type: 'item',
  },
  {
    title: 'Shared Resources',
    path: '/shared',
    icon: <PeopleOutlinedIcon />,
    type: 'item',
  },
  {
    title: 'Starred',
    path: '/starred',
    icon: <StarBorderOutlinedIcon />,
    type: 'item',
  },
  {
    title: 'Bin',
    path: '/trash',
    icon: <DeleteOutlineOutlinedIcon />,
    type: 'item',
  },
  {
    title: 'Settings',
    icon: <SettingsOutlinedIcon />,
    type: 'submenu',
    subNav: [
      {
        title: 'Marketplace Management',
        path: '/settings/marketplace-management',
        type: 'item',
      },
      {
        title: 'Organisation Management',
        path: '/settings/organisation-management',
        type: 'item',
      },
    ],
  },
  // {
  //   title: 'Settings',
  //   icon: <SettingsOutlinedIcon />,
  //   type: 'submenu',
  //   subNav: [
  //     {
  //       title: 'Profile',
  //       path: '/',
  //       icon: <ManageAccountsOutlinedIcon />,
  //       type: 'item',
  //     },
  //     {
  //       title: 'General',
  //       path: '/',
  //       icon: <SettingsApplicationsOutlinedIcon />,
  //       type: 'item',
  //     },
  //   ],
  // },
  // {
  //   type: 'divider',
  // },
  // {
  //   title: 'Saved reports',
  //   type: 'subheader',
  // },
];

export const ResitrictedSidebarData = [
  {
    title: 'Settings',
    icon: <SettingsOutlinedIcon />,
    type: 'submenu',
    subNav: [
      {
        title: 'Organisation Management',
        path: '/settings/organisation-management',
        type: 'item',
      },
    ],
  },
];
